import SystemModal from "../Common/SystemModal";
import { useState } from "react";
import ajaxRequisitions from "../../util/remote/ajaxRequisitions";
import toast, { Toaster } from "react-hot-toast";

const RequistionUpdateApprovalLevel = ({ data, funct, org }) => {
  const [approvalLevel, setApprovalLevel] = useState(data.approval_level || "");
  const [updating, setUpdating] = useState(false);
  const [settingReady, setSettingReady] = useState(false);

  // ---- org defaults (override by passing `org` prop) ----
  const orgInfo = {
    name: "LA_PROCURE AFRICA LIMITED",
    lines: [
      "P.O.BOX 28775 KAMPALA",
      "PLOT 79B BOMBO ROAD",
      "TEL: +256700000001",
      "EMAIL: info@laprocure.africa",
    ],
    logoSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    watermarkSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    ...org,
  };

  // handle approval update
  const handleUpdateApproval = async (e, controls) => {
    if (!approvalLevel) {
      toast.error("Approval level cannot be empty");
      return;
    }
    setUpdating(true);
    const response = await ajaxRequisitions.updateApprovalLevel({
      reqID: data.id,
      level: approvalLevel,
    });
    setUpdating(false);
    if (response.status === "OK") {
      funct();
      toast.success("Approval level updated successfully");
      controls.close();
    } else {
      toast.error(response.message);
    }
  };

  // handle "ready to order"
  const handleSetReady = async (e, controls) => {
    e.preventDefault();

    if (
      !window.confirm(
        "Are you sure you want to mark this requisition as Ready to Order?"
      )
    ) {
      return;
    }

    setSettingReady(true);
    const response = await ajaxRequisitions.setReadyToOrder({
      reqID: data.id,
      status: 10,
    });
    setSettingReady(false);

    if (response.status === "OK") {
      funct();
      toast.success("Requisition marked as Ready to Order");
      setTimeout(() => {
        controls.close();
      }, 3000);
    } else {
      toast.error(response.message);
    }
  };

  const Print = (e) => {
    e.preventDefault();
    const html = document.getElementById("printablediv").innerHTML;
    const w = window.open("", "parent");
    w.document.open();
    w.document.write(`
      <html>
        <head>
          <title>Material Requisition</title>
          <style>
            ${baseStyles(orgInfo.watermarkSrc)}
          </style>
        </head>
        <body>
          ${html}
        </body>
      </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    w.onafterprint = () => w.close();
  };

  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdateApproval(e, controls)}
        disabled={updating}
      >
        {updating ? "Updating..." : "Update Approval"}
      </button>
      <button
        className="btn btn-warning"
        onClick={(e) => handleSetReady(e, controls)}
        disabled={settingReady}
      >
        {settingReady ? "Processing..." : "Set Ready to Order"}
      </button>
      <button className="btn btn-dark" onClick={Print}>
        Print
      </button>
    </>
  );

  return (
    <SystemModal title="Requisition Details" size="xl" footer={RenderFooter}>
      <Toaster />
      <style>{baseStyles(orgInfo.watermarkSrc)}</style>
      <div id="printablediv">
        <div className="doc">
          <div className="doc-content">
            <div className="doc-header">
              <div className="logo-wrap">
                <img src={orgInfo.logoSrc} alt="Logo" />
              </div>
              <div className="org-text">
                <div className="org-name">{orgInfo.name}</div>
                {orgInfo.lines.map((l, i) => (
                  <div key={i} className="org-line">
                    {l}
                  </div>
                ))}
              </div>
            </div>
            <div className="title">MATERIAL REQUISITION FORM</div>
            {/* Meta table */}
            <table className="meta">
              <tbody>
                <tr>
                  <td>
                    <b>Date:</b> {data.date_created}
                  </td>
                  <td>
                    <b>Requisition ID:</b> {data.id}
                  </td>
                  <td>
                    <b>Status:</b>{" "}
                    {data.status === "1" ? "Approved" : "Pending"}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Department:</b> {data.department}
                  </td>
                  <td>
                    <b>Prepared By:</b> {data.first_name} {data.last_name}
                  </td>
                  <td>
                    <b>Approval Level:</b>
                    <input
                      style={{ border: "red 2px dotted" }}
                      type="text"
                      autoFocus
                      value={approvalLevel}
                      onChange={(e) => setApprovalLevel(e.target.value)}
                      className="form-control form-control-sm"
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    <b>Narration:</b> {data.naration}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* Items table */}
            <table className="items">
              <thead>
                <tr>
                  <th style={{ width: "70px" }}>Stock #</th>
                  <th>Item Description</th>
                  <th style={{ width: "90px" }}>Unit</th>
                  <th style={{ width: "90px" }}>Qty</th>
                  <th style={{ width: "130px" }}>Est. Unit cost</th>
                  <th style={{ width: "130px" }}>Actual Cost</th>
                  <th style={{ width: "130px" }}>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data.items) && data.items.length > 0 ? (
                  data.items.map((it, idx) => (
                    <tr key={it.id}>
                      <td>{idx + 1}</td>
                      <td>{it.item_name}</td>
                      <td>{it.unit}</td>
                      <td>{it.quantity}</td>
                      <td>{it.est_unit_cost}</td>
                      <td>{it.actual_cost ?? "-"}</td>
                      <td>{it.sub_total ?? "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      No items
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* Totals */}
            <div className="totals">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <b>Estimated Total</b>
                    </td>
                    <td>{data.est_total}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Real Total</b>
                    </td>
                    <td>{data.real_total ?? "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Signature */}
            <div className="signature">
              <div>
                <b>Department Supervisor Approval Signature:</b>
              </div>
              <div className="line"></div>
            </div>
          </div>
          <div className="footer-print">
            Printed on: {new Date().toLocaleString()}
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

// shared CSS for preview + print (watermark via ::before so opacity works)
const baseStyles = (watermarkSrc) => `
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; }
  .doc {
    position: relative;
    padding: 18mm 15mm;
    min-width: 210mm;
    max-width: 210mm; /* A4 width */
    margin: 0 auto;
    background: #fff;
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .doc::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url("${watermarkSrc}") no-repeat center center;
    background-size: 60%;
    opacity: 0.2; /* 👈 control watermark opacity here */
    z-index: 0;
  }
  .doc-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
  }
  .doc-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
    position: relative;
    z-index: 2;
  }
  .logo-wrap img { width: 180px; height: 180px; object-fit: contain; }
  .org-text { flex: 1; text-align: center; }
  .org-name { font-size: 20px; font-weight: 700; letter-spacing: .5px; }
  .org-line { font-size: 12px; line-height: 1.2; }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    margin: 6px 0 10px 0;
    position: relative; z-index: 2;
  }
  table { border-collapse: collapse; width: 100%; margin-top: 10px; position: relative; z-index: 2; }
  th, td { border: 1px solid #111; padding: 6px 8px; font-size: 12.5px; vertical-align: top; }
  th { background: #f2f2f2; text-align: left; }
  .meta { margin-bottom: 12px; }
  .meta td { border: 1px solid transparent; padding: 4px 0; font-size: 13px; }
  .meta tr td:first-child, .meta tr td:nth-child(2), .meta tr td:nth-child(3) { border: none; }
  .items th:nth-child(4) { width: 40%; }
  .totals { margin-top: 16px; width: 260px; }
  .totals td:first-child { width: 60%; }
  .signature { margin-top: auto; }
  .signature .line { margin-top: 16px; border-bottom: 1px solid #111; width: 60%; height: 20px; }
  .footer-print { margin-top: 18px; font-size: 11px; text-align: right; color: #374151; position: relative; z-index: 2; }
  @page { size: A4; margin: 12mm; }
`;

export default RequistionUpdateApprovalLevel;
